import { Main } from '@pages/goodpay/Main';
import { CardInfo } from '@pages/goodpay/CardInfo';
import {
  goodpayPay,
  goodpayPayFailed,
  goodpayPaySuccess
} from '@root/constants/paths';
import CustomSuccess from '@root/components/CustomSuccess';
import CustomFailed from '@root/components/CustomFailed';
import { formPayData, getGoodPayContentData } from '@root/constants/formData';

const { main } = getGoodPayContentData();

export const getGoodPayRoutes = () => [
  {
    path: goodpayPay(),
    element: (
      <Main
        mainContent={main}
        formData={formPayData}
        redirectPaths={{
          success: goodpayPaySuccess,
          failed: goodpayPayFailed
        }}
      >
        <CardInfo userData={undefined as never} />
      </Main>
    )
  },
  {
    path: goodpayPaySuccess(),
    element: <CustomSuccess />
  },
  {
    path: goodpayPayFailed(),
    element: <CustomFailed />
  }
];
